import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdManagementService } from 'src/app/services/ad-management/ad-management.service';
import { CachingService } from 'src/app/services/caching/caching.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DPE } from 'src/app/models/dpe';
import { Ad } from 'src/app/models/ad';
import { TransactionType } from 'src/app/models/transactionType';

@Component({
  selector: 'app-ad-edit',
  templateUrl: './ad-edit.component.html',
  styleUrls: ['./ad-edit.component.css'],
  providers: [AdManagementService, CachingService]
})

export class AdEditComponent implements OnInit {
  public ad: Ad;
  public dpeList: Array<string> = Object.keys(DPE);
  public transactionList: Array<string> = Object.keys(TransactionType);
  public photoAssetsBaseUrl: string;

  constructor(
    private adManagementService: AdManagementService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private cachingService: CachingService,
  ) {
    this.dpeList = Object.keys(DPE);
    this.transactionList = Object.keys(TransactionType);
    this.photoAssetsBaseUrl = environment.photoAssetsBaseUrl;
  }

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const id = params.get('id');
          if (id != null) {
            // FIXME: if secret has not been set yet, bootstrap the security mechanism
            return this.adManagementService.getAd(id, this.cachingService.getSecret());
          }
          return of(
            new Ad("", "", 0, 0, "", "", [], true, TransactionType.Location, DPE.Vierge));
        }))
      .subscribe(
        ad => this.ad = ad,
        error => {
          this.handleError("ngOnInit()", error);
          this.ad = new Ad("", "", 0, 0, "", "", [], true, TransactionType.Location, DPE.Vierge);
        });
  }

  private handleError(operation: string, error: string) {
    const errorDetails = `error in ${operation}() raising ${error}`;
    console.error(errorDetails);
    this.toastr.error(errorDetails);
  }

  public removePhoto(photoId: string): void {
    const photoIndex = this.ad.images.indexOf(photoId, 0);
    if (photoIndex > -1) {
      this.ad.images.splice(photoIndex, 1);
      this.toastr.success('Photo supprimée');
    }
  }

  public doNotRemovePhoto(): void {
    this.toastr.info('Photo non supprimée');
  }

  private swapPhotos(photoIndex1: number, photoIndex2: number): void {
    const tmp = this.ad.images[photoIndex1];
    this.ad.images[photoIndex1] = this.ad.images[photoIndex2];
    this.ad.images[photoIndex2] = tmp;
  }

  public movePhotoUp(photoId: string): void {
    const photoIndex = this.ad.images.indexOf(photoId, 0);
    if (photoIndex > 0) {
      this.swapPhotos(photoIndex, photoIndex - 1);
      this.toastr.success('Photo remontée');
    }
  }

  public movePhotoDown(photoId: string): void {
    const photoIndex = this.ad.images.indexOf(photoId, 0);
    if (photoIndex > -1 && photoIndex < this.ad.images.length - 1) {
      this.swapPhotos(photoIndex, photoIndex + 1);
      this.toastr.success('Photo descendue');
    }
  }

  public createPhoto(event: any): void {
    const photoId = this.createGuid();
    this.adManagementService
      .createPhoto(
        photoId,
        event.target.files[0],
        this.cachingService.getSecret())
      .subscribe(
        uploadTask => uploadTask.subscribe(
          _ => this.ad.images.push(photoId),
          error => this.handleError("createPhoto(event: any)", error)),
        error => this.handleError("createPhoto(event: any)", error));
  }

  private createGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // tslint:disable-next-line:no-bitwise
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public saveAd(): void {
    if (this.ad.id === "") {
      this.ad.id = this.createGuid();
    }
    this.adManagementService
      .putAd(this.ad, this.cachingService.getSecret())
      .subscribe(
        _ => {
          this.router.navigate(['edit/' + this.ad.id]);
          this.toastr.success('Annonce sauvée');
        },
        error => {
          this.handleError("saveAd()", error);
        });
  }

  public doNotSaveAd(): void {
    this.toastr.info('Annonce non sauvée');
  }

  public goBack(): void {
    this.router.navigate(['admin']);
  }
}
